import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
// import moment from 'moment-timezone'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHandPointLeft, faHandPointRight } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faFacebookSquare, faInstagram, faInstagramSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { VueReCaptcha } from 'vue-recaptcha-v3'

library.add(faFacebook, faFacebookSquare, faInstagram, faInstagramSquare, faHandPointLeft, faHandPointRight)

Vue.use(VueReCaptcha, { siteKey: '6LfolPUUAAAAADdsO7gFZCfiFVXeGkwXRZKW8t6U',
  loaderOptions: {
    autoHideBadge: true
  }
})

// moment.tz.setDefault('America/Chicago')

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

// Setup axios with default url
Vue.use({
  install (Vue) {
    Vue.prototype.$api = axios.create({
      baseURL: process.env.VUE_APP_BASE_URL
    })
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
